import { PartnerDetails } from '../../models/partner';
import { customerHubHttp } from '../customer-hub-api';

export const getPartner = async (
  id: string,
  abortController?: AbortController
): Promise<PartnerDetails | null> => {
  try {
    const url = `/jabra-locator/partner/${encodeURIComponent(id)}`;

    const response = await customerHubHttp.get<PartnerDetails>(url, {
      signal: abortController?.signal,
    });

    return response?.data ?? null;
  } catch (error) {
    console.error(`Error fetching partner:`, error);
    return null;
  }
};
